const Host = require('./hosts')

const { rzrq } = Host(process.env.NODE_ENV)

module.exports = {
  stockDistribute: `${rzrq}/deal/queryHeshengStockUpDownDistrubrite`, // 涨跌分布
  riseAndFall: `${rzrq}/deal/queryHeshengRealTimeStockUpDown`, // 涨跌分布
  distributeTable: `${rzrq}/deal/queryStockSortRange`,
  queryrzrq: `${rzrq}/deal/queryrzrq`, // 获取融资融券
  queryHistoryRzRq: `${rzrq}/deal/queryHistoryRzRq`, // 获取历史融资融券
  queryFinaBalanceRatioTable: `${rzrq}/deal/queryFinaBalanceRatioTable`, // 融资余额占流值比排行
  queryFinaSecuAllTopFiveTable: `${rzrq}/deal/queryFinaSecuAllTopFiveTable`, // 融资净买卖前五
  queryHistoryFinaSecuRqTable: `${rzrq}/deal/queryHistoryFinaSecuRqTable`, // 历史两融余额差值
  query2FinaSecuTable: `${rzrq}/deal/query2FinaSecuTable`, // 两融余额差值
  queryFinaSecuIndidualDetailRongquanTable: `${rzrq}/deal/queryFinaSecuIndidualDetailRongquanTable`, // 个股两融买卖明细
  queryFinaSecuIndividualHistoryRongquanTable: `${rzrq}/deal/queryFinaSecuIndividualHistoryRongquanTable`, // 历史两融买卖明细
  queryFinaSecuTradingValueLineChart: `${rzrq}/deal/queryFinaSecuTradingValueLineChart`, // 融资融券余额
  queryFinaSecuLineChart: `${rzrq}/deal/queryFinaSecuLineChart`, // 融资 融券（折线图）
  queryFinaSecuRatioLineChart: `${rzrq}/deal/queryFinaSecuRatioLineChart`, // 融资融券占流通市值比 （折线图）
  queryFinaSecuDiffLineChart: `${rzrq}/deal/queryFinaSecuDiffLineChart`, // 两融余额差值（折线图）
  query2IndividualStockFinaSecuTable: `${rzrq}/deal/query2IndividualStockFinaSecuTable`, // 个股融资融券余额差值
  queryIndividualStockFiSeDiffByCode: `${rzrq}/deal/queryIndividualStockFiSeDiffByCode`, // 个股历史两融余额差值
  queryIndividualStockFiSeByCode: `${rzrq}/deal/queryIndividualStockFiSeByCode`, // 个股融资融券折线图
  queryIndividualFiSeByCode: `${rzrq}/deal/queryIndividualFiSeByCode`, // 个股历史两融买卖明细
  queryStockSearch: `${rzrq}/deal/queryStockSearch`, // 个股模糊搜索
  queryGlobalIndex: `${rzrq}/deal/queryGlobalIndex`, // 全球指数
  querySHAShareTable: `${rzrq}/deal/querySHAShareTable`, // 首页资金流
  queryFinaSecuTopFiveTable: `${rzrq}/deal/queryFinaSecuTopFiveTable`
}